<template>
  <div class="mx-5">
    <v-breadcrumbs class="m-2 p-0" :items="breadcrumbsItems">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>

    <v-row>
      <v-col cols="12">
        <v-card class="mb-5">
          <v-card-title class="list-title">
            <span>Servis Logları</span>
          </v-card-title>

          <v-card-text>
            <ServiceLogsPanel />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ServiceLogsPanel from './ServiceLogsPanel.vue';

export default {
  name: 'ServiceLogs',
  components: { ServiceLogsPanel },
  data() {
    return {
      breadcrumbsItems: [
        { text: 'Ana Sayfa', disabled: false, href: '#/' },
        { text: 'Servis Logları', disabled: true }
      ]
    };
  }
};
</script>

<style scoped>
.list-title {
  background-color: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
}
</style>
